import * as ModelTypeActionType from './constants';
import * as CommonActionType from '../Common/constants';

const defaultParams = {
  projectId: null,
  name: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  totalRecord: 0,
  totalPage: 0
};

const defaultRoomModelParams = {
  modelId: null,
  name: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  totalRecord: 0,
  totalPage: 0
};

const ModelProfile = {
  id: '',
  projectId: '',
  name: '',
  code: '',
  note: ''
};

const ManageModels = {
  items: [],
  params: defaultParams
};

const ManageRoomsModels = {
  items: [],
  params: defaultRoomModelParams
};

const ModelState = {
  ManageModels: ManageModels,
  ModelProfile: ModelProfile,
  ManageRoomsModels: ManageRoomsModels,
  ErrorMsg: [],
  AddRoomToModelErrorMsg: [],
  dateTime: new Date(),
  IsSuccessStep2: false,
  IsOpenFormEdit: false,
  IsOpenPopUpRoomModel: false,
  SelectListRooms: [],
  SelectListPlan: []
};

export default function ModelStore(state = ModelState, action) {
  switch (action.type) {
    case ModelTypeActionType.SEARCH_MODEL_SUCCESS:
      return processSearchSuccess(state, action);
    case ModelTypeActionType.SEARCH_ROOM_MODEL_SUCCESS:
      return processSearchRoomModelSuccess(state, action);
    case ModelTypeActionType.SEARCH_ROOM_MODEL_ASYNC:
      return {
        ...state,
        AddRoomToModelErrorMsg: ''
      };
    case ModelTypeActionType.CREATE_UPDATE_MODEL_ERROR:
      return {
        ...state,
        ErrorMsg: [action.data.error],
        ModelProfile: {
          ...state.ModelProfile,
          name: action.data.params.name
        },
        IsOpenFormEdit: action.data.isEdit,
        IsOpenPopUpRoomModel: false
      };
    case ModelTypeActionType.ADD_ROOM_TO_MODEL_ERROR:
      return {
        ...state,
        AddRoomToModelErrorMsg: action.data.error
      };
    case ModelTypeActionType.GET_MODEL_BY_ID_SUCCESS:
      return processGetByIdSuccess(state, action);
    case ModelTypeActionType.OPEN_POPUP_ROOM_MODEL:
      return {
        ...state,
        IsOpenFormEdit: false,
        IsOpenPopUpRoomModel: true,
        SelectListRooms: [],
        ErrorMsg: [],
        ManageRoomsModels: {
          items: [],
          params: defaultRoomModelParams
        }
      };
    case CommonActionType.COMMON_SELECT_LIST_ROOM_SUCCESS:
      return {
        ...state,
        SelectListRooms: action.data
      };
    case ModelTypeActionType.RESET_MODEL:
      return {
        ...state,
        ManageModels: ManageModels,
        ErrorMsg: [],
        dateTime: new Date(),
        IsSuccessStep2: false,
        IsOpenFormEdit: false,
        IsOpenPopUpRoomModel: false
      };
    case ModelTypeActionType.GET_LIST_MODEL_BY_PROJECT_SUCCESS:
      return {
        ...state,
        SelectListPlan: action.data
      };
    case ModelTypeActionType.RESET_ERROR_MESSAGE_MODEL:
      return {
        ...state,
        ErrorMsg: []
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageModels = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageModels: manageModels,
    ErrorMsg: [],
    IsOpenPopUpRoomModel: false,
    IsOpenFormEdit: false
  };
};

const processSearchRoomModelSuccess = (state, action) => {
  var result = action.data;
  var manageRoomsModels = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    AddRoomToModelErrorMsg: [],
    ManageRoomsModels: manageRoomsModels
  };
};

const processGetByIdSuccess = (state, action) => {

  return {
    ...state,
    ModelProfile: action.data,
    ErrorMsg: [],
    IsOpenFormEdit: true,
    IsOpenPopUpRoomModel: false
  };
};



// WEBPACK FOOTER //
// ./src/Model/reducers.js